import src from "IMAGE";
export default { src, width: 540, height: 540, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAPUlEQVR42q3OMQ0AIBBD0QthIgQPoIEFByz4QAgqUHtfQMdr8qZ2qFl0ChayKis2ProaTDxcJDVoOBixrx13xwL22J90vwAAAABJRU5ErkJggg=="};
